import React from 'react';

import styles from '../../styles.module.scss';
import NextButton from './NextButton';
import ShareButton from './ShareButton';

type BottomActionsProps = {
  showNext?: boolean;
  onNextClick?: () => void;
  isNextDisabled?: boolean;

  showShare?: boolean;
  onShareClick?: () => void;
  isShareDisabled?: boolean;
  shareText?: string;
  flashbackType?: number;
};

const BottomActions = ({
  showNext = false,
  onNextClick = () => {},
  isNextDisabled = false,
  showShare = false,
  onShareClick = () => {},
  isShareDisabled = false,
  shareText,
  flashbackType
}: BottomActionsProps) => {
  if (!showNext && !showShare) {
    return null;
  }

  return (
    <div className={styles.bottomActionsContainer}>
      {showShare && (
        <ShareButton
          onClick={onShareClick}
          disabled={isShareDisabled}
          text={shareText}
          flashbackType={flashbackType}
        />
      )}
      {showNext && (
        <NextButton
          onClick={onNextClick}
          disabled={isNextDisabled}
          flashbackType={flashbackType}
        />
      )}
    </div>
  );
};

export default BottomActions;
